import { usePostCreateDossier } from "src/networking/terminals/signature/signature.gates";
import {
  AuthType,
  CreateDossierRequestBodyDTO,
  Formik,
  FormikDraftCAI,
  SignatureType,
} from "src/types";
import { useDraftIDStore } from "src/storage/formik/formik-draft.store";

export const useDataEntrySignatureAStep = (formik: Formik<FormikDraftCAI>) => {

  const { crossGate: postCreateDossier } = usePostCreateDossier();
  const draftId = useDraftIDStore((state) => state.draftID);

  const { values } = formik;

  const createDossier = (authType: AuthType) => {
    const phone = values.vehicleA.driver.phoneNumber;
    const email = values.vehicleA.driver.email;

    if (!draftId || (!phone && !email)) return;

    const body: CreateDossierRequestBodyDTO = {
      idRichiesta: draftId,
      firmatario: {
        tipo: SignatureType.DRIVER_A,
        tipoAutenticazione: authType,
        telefono: phone.formattedPhone,
        email: email,
      },
    };

    postCreateDossier(
      { body },
      {
        onSuccess: (response) => {
          window.location.replace(response.dossier);
        }
      },
    );
  };

  return { createDossier };
};
